import { motion } from "framer-motion";
import CSS from "./HomePageCSS.module.css";
import Marquee from "react-fast-marquee";
import logo from "../../assets/brand/logo-scrolling.svg";
import Slider from "../../components/opinions/Slider";
import ContactSection from "../../components/contact-section/ContactSection";

const HomePage = () => {
  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      className={CSS.main}
    >
      <section className={CSS.bg_image}>
        <h1 className={CSS["main-heading"]}>
          Sending <span>IVF biomaterials</span>
          <br />
          for the first time?
        </h1>
        <h2 className={CSS.answer}>We will help!</h2>
        <h2 className={CSS.motto}>
          your reliable <span>medical courier</span>
        </h2>
        <Marquee className={CSS.marquee} autoFill speed="40">
          <h2>ivf delivery to ukraine</h2>
          <img src={logo} alt="logo" />
        </Marquee>
      </section>
      <Slider />
      <ContactSection />
    </motion.main>
  );
};

export default HomePage;
